// homemade simple function to turn a string into an unreadable string.

export const stringToHash = (str: string,len : number) => {
    let hash = 0;

    for(let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
    }

    return Math.abs(hash).toString(16).padStart(len, '0');
} 